import cx from 'classnames'
import { observer } from 'mobx-react-lite'

import { ReactComponent as BulletedListIcon } from 'assets/icons/listBulleted24.svg'
import { useBulletListToggle } from 'common/Prose/Toolbar/hooks/useBulletListToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import MStyles from '../MobileToolbar.module.scss'

export const BulletListButton = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active: selected, handleClick } = useBulletListToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Turn into bulleted list"
      className={cx(MStyles.button, {
        [MStyles.buttonSelected]: selected,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-bulleted-list-mark"
      {...props}
    >
      <BulletedListIcon />
    </Button>
  )
})
